import styled from 'styled-components';
export const PriceFilterWrapper = styled.div `
  display: flex;
  align-items: center;
`;
export const PriceFilterDivider = styled.div `
  margin: 0.4rem;
  border-bottom: 1px black solid;
  width: 10px;
`;
export const PriceFilterInputWrapper = styled.div `
  width: 140px;
  position: relative;
  input { padding: 10px 22px 10px 10px }
  ${props => props.theme.mixins.mobile('width: 220px;')};
  @media (max-width: 550px) { width: 100%; }
`;
export const PriceCurrencySign = styled.div `
  position: absolute;
  top: 50%;
  right: 10px;
  z-index: 1;
  transform: translateY(calc(-50%));
`;
export const MultiRangeContainer = styled.div `
  width: 100%;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  margin-top: 20px;
  margin-bottom: 5px;
  ${props => props.theme.mixins.mobile(`
    width: 470px;
    margin-bottom: 0;
  `)};
  @media (max-width: 550px) { width: 100%; }
`;
export const RangeInput = styled.input `
  width: 100%;
  pointer-events: none;
  position: absolute;
  outline: none;
  height: 0;
  -webkit-appearance: none;
  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    -webkit-tap-highlight-color: transparent;
    pointer-events: all;
    cursor: pointer;
    position: relative;
    border: none;
    width: 14px;
    height: 14px;
    background-color: ${props => props.theme.input.borderColors.secondary};
    border-radius: 50%;
    ${props => props.theme.mixins.mobile(`
      background-clip: padding-box;
      border: 0.3rem solid transparent;
      transform: scale(2.5);
    `)};
  }
  &::-moz-range-thumb {
    -webkit-appearance: none;
    -webkit-tap-highlight-color: transparent;
    pointer-events: all;
    cursor: pointer;
    position: relative;
    border: none;
    width: 14px;
    height: 14px;
    background-color: ${props => props.theme.input.borderColors.secondary};
    border-radius: 50%;
    ${props => props.theme.mixins.mobile(`
      background-clip: padding-box;
      border: 0.3rem solid transparent;
      transform: scale(2.5);
      box-sizing: border-box;
    `)};
  }
  ${props => props.zIndex && `z-index: ${props.zIndex};`}
`;
export const Slider = styled.div `
  position: relative;
  width: 100%;
  margin-bottom: 2px;
`;
export const SliderTrack = styled.div `
  position: absolute;
  height: 2px;
  background-color: ${props => props.theme.input.borderColors.default};
  z-index: 1;
  width: 100%;
  border-radius: 3px;
`;
export const SliderRange = styled.div `
  position: absolute;
  height: 2px;
  background-color: ${props => props.theme.input.borderColors.secondary};
  z-index: 2;
  left: ${props => props.left ? `${props.left}%` : 0};
  ${props => props.width && `width: ${props.width}%;`}
`;
